import React from 'react'
import Svg from '../Svg'

export default ({
  width = 20,
  height = 20,
  'aria-label': ariaLabel,
  className = '',
}) =>
  <Svg
    className={ className }
    width={ width }
    height={ height }
    viewBox="0 0 1024 1024"
    aria-label={ ariaLabel }
  >
    <path d="M985.385 777.5c0-265.5-236-206.5-236-413 0-17.11-1.648-31.73-4.653-44.183-15.515-104.188-84.956-187.805-174.947-213.285 0.797-3.638 1.215-7.405 1.215-11.255 0-30.678-26.55-55.777-59-55.777s-59 25.099-59 55.775c0 3.855 0.421 7.619 1.215 11.255-100.92 28.578-175.999 130.258-178.154 252.078-0.035 1.77-0.061 3.564-0.061 5.391 0 206.502-236 147.502-236 413.002 0 70.271 157.264 129.061 367.8 143.885 19.844 37.249 59.051 62.615 104.2 62.615s84.358-25.366 104.2-62.615c210.54-14.829 367.8-73.614 367.8-143.885 0-0.208-0.026-0.421-0.028-0.627l1.408 0.627zM801.696 827.371c-49.995 13.34-108.928 22.931-172.178 28.253-5.259-60.308-55.847-107.624-117.518-107.624s-112.259 47.316-117.518 107.624c-63.248-5.322-122.183-14.913-172.178-28.253-68.8-18.359-101.69-38.895-113.728-49.871 12.038-10.976 44.928-31.512 113.728-49.871 79.992-21.342 182.872-33.099 289.696-33.099s209.704 11.757 289.696 33.099c68.8 18.359 101.69 38.895 113.728 49.871-12.038 10.976-44.928 31.512-113.728 49.871z"/>
  </Svg>
